import { FC, useState } from "react";
import { FieldRenderProps } from "react-final-form";

import { Input, SpacingToken, Switch, Text } from "@livechat/design-system-react-components";

import { FormFieldNoMargin } from "components/design-system-adapters/styled/form-field";
import Flex from "components/layout/Flex";
import { FormBlockType } from "store/entities/contact-forms/interfaces";
import { withVar } from "themes/helpers";

import { BLOCK_DEFAULTS, GENERIC_REQUIRED_MESSAGE } from "../../constants";

export const RequiredErrorField: FC<FieldRenderProps<string>> = ({ input, meta, blockType }) => {
  const getRequiredError = (blockType: FormBlockType): string => {
    const defaults = BLOCK_DEFAULTS[blockType as FormBlockType];
    if (!defaults || !("requiredError" in defaults)) {
      return GENERIC_REQUIRED_MESSAGE;
    }
    return defaults.requiredError;
  };
  const defaultErrorMessage = getRequiredError(blockType);
  const [isCustomError, setIsCustomError] = useState<boolean>(input.value !== defaultErrorMessage);
  const [rememberedMessage, setRememberedMessage] = useState<string>(defaultErrorMessage);
  const handleToggleRequiredMessage = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const value = event.target.checked;
    if (!value) {
      setIsCustomError(false);
      input.onChange(GENERIC_REQUIRED_MESSAGE);
    } else {
      setIsCustomError(true);
      input.onChange(rememberedMessage);
    }
  };

  const handleChangeRequiredMessage = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setRememberedMessage(event.target.value);
    input.onChange(event.target.value || "");
  };

  return (
    <Flex marginV={withVar(SpacingToken.Spacing2)} gap={withVar(SpacingToken.Spacing2)} column>
      <Flex
        alignItems="center"
        onClick={() => {
          setIsCustomError(!isCustomError);
        }}
      >
        <Switch size="medium" on={isCustomError} onChange={handleToggleRequiredMessage} />
        <Text
          size="md"
          css={{ marginLeft: withVar(SpacingToken.Spacing2), marginRight: withVar(SpacingToken.Spacing1) }}
        >
          Custom error message
        </Text>
      </Flex>
      {isCustomError && (
        <FormFieldNoMargin labelText="Error message content" error={meta.error}>
          <Input error={meta.error} value={input.value} onChange={handleChangeRequiredMessage} />
        </FormFieldNoMargin>
      )}
    </Flex>
  );
};
